const CONTROL_SELECTOR = "button, input, textarea, select"
const EDITOR_EVENTS = new Set(["mousedown", "copy", "cut", "paste"])

// Replaces Tiptap's default, which only starts a drag from a
// `[data-drag-handle]` and swallows every drag event over the node, so a media
// block could neither be picked up nor dropped beside.
export function stopMediaNodeViewEvent(
	event: Event,
	isEditable: boolean,
): boolean {
	if (event.type === "dragstart" && !isEditable) {
		event.preventDefault()
		return true
	}
	if (event.type.startsWith("drag") || event.type === "drop") return false
	const target = event.target
	if (target instanceof Element && target.closest(CONTROL_SELECTOR)) return true
	return !EDITOR_EVENTS.has(event.type)
}
